import React from 'react';
import { ContactResponse } from '@/main/models/response';
import { getTranslateByKey, isEmpty } from '@/main/services/utils';
import WhatsappLink from '@/main/components/shared/whatsappLink/whatsappLink';

import { IInfoProcurement } from '../accordionContacts';
import * as S from './styles';


export interface IContactCardProps {
  contact: ContactResponse;
  infoProcurement: IInfoProcurement;
}

function ContactCard({
  contact,
  infoProcurement
}: IContactCardProps) {
  return (
    <S.DivHistory>
      <S.InformationType>
        <span>{getTranslateByKey('information.contactType')}:</span>
        {contact.contactType ? contact.contactType.name : ''}
      </S.InformationType>
      <S.InformationType>
        <span>{getTranslateByKey('information.name')}:</span>
        {contact.firstName && contact.lastName
          ? `${contact.firstName} ${contact.lastName}`
          : ''}
      </S.InformationType>

      <S.InformationType>
        <span>{getTranslateByKey('information.phoneNr')}:</span>
        {!isEmpty(contact.phone) &&
          <WhatsappLink
            phone={contact.phone}
            isWhatsapp={contact.phoneIsWhatsApp}
            companyName={infoProcurement.companyName}
            claimNumber={infoProcurement.claimNumber}
            orderNumber={infoProcurement.orderNumber}
            vehicleName={infoProcurement.vehicleName}
            insurerName={infoProcurement.insurerName}
          />
        }
      </S.InformationType>

      <S.InformationType>
        <span>{getTranslateByKey('information.extension')}:</span>
        {contact.extension ? contact.extension : ''}
      </S.InformationType>

      <S.InformationType>
        <span>{getTranslateByKey('information.cellphoneNr')}:</span>
        {contact.cellphone &&
          <WhatsappLink
            phone={contact.cellphone}
            isWhatsapp={contact.cellphoneIsWhatsApp}
            companyName={infoProcurement.companyName}
            claimNumber={infoProcurement.claimNumber}
            orderNumber={infoProcurement.orderNumber}
            vehicleName={infoProcurement.vehicleName}
            insurerName={infoProcurement.insurerName}
          />
        }
      </S.InformationType>

      <S.InformationType>
        <span>{getTranslateByKey('information.email')}:</span>
        {contact.email ? contact.email : ''}
      </S.InformationType>
    </S.DivHistory>
  );
}

export default ContactCard;
